import React from 'react';
import Style from './About.module.scss';
import Terminal from './Terminal';
import { Box } from '@mui/material';
import { infoEn } from '../../info/InfoEn';
import { TypeShuffle } from '../../vendor/typeShuffle';
import { preloadFonts } from '../../vendor/utils';


export default function About() {

    preloadFonts('JetBrains Mono').then(() => {
        const textElement = document.querySelector('.aboutMeText');
        const ts = new TypeShuffle(textElement);
        ts.trigger('fx6');
        const textElement2 = document.querySelector('.aboutMeText1');
        const ts1 = new TypeShuffle(textElement2);
        ts1.trigger('fx6');
        const textElement3 = document.querySelector('.aboutMeText2');
        const ts2 = new TypeShuffle(textElement3);
        ts2.trigger('fx6');
        const textElement4 = document.querySelector('.aboutMeText3');
        const ts3 = new TypeShuffle(textElement4);
        ts3.trigger('fx6');
    });

    const firstName = infoEn.firstName.toLowerCase();

    function aboutMeText() {
        return <>
            <dl className="aboutMeText">
                <p><span style={{ color: infoEn.baseColor }}>C:\Users\berkantaslan&gt;</span> python </p>
                <p><span style={{ color: infoEn.baseColor }}>C:\Users\berkantaslan&gt;</span> Python 3.10.11 (tags/v3.10.11:7d4cc5a, Apr 5 2023, 00:38:17) [MSCv.1929 64 bit (AMD64)] on win32
                    Type &quot;help&quot;, &quot;copyright&quot;, &quot;credits&quot; or &quot;license&quot; for more information. </p>
                <p>&gt;&gt;&gt; import os</p>
                <p>&gt;&gt;&gt; import glob</p>
                <p>&gt;&gt;&gt; import json</p>
                <p>&gt;&gt;&gt; with open(&quot;berkantaslan.json&quot;) as code: berkantaslan = json.load(code) </p>
                <p>&gt;&gt;&gt; print(berkantaslan[&quot;About&quot;])</p>
                <p> {infoEn.bio}</p>
                <p>&gt;&gt;&gt; print(berkantaslan[&quot;Military Service Situation&quot;])</p>
                <p> Done </p>

            </dl>

            <p>&gt;&gt;&gt; print(berkantaslan[&quot;Driving Licence&quot;]) # 🚗 </p>
            <p> B Class </p>
            <p> &gt;&gt;&gt; print(berkantaslan[&quot;Cigarette Using&quot;]) # 🚭 </p>
            <p> Don&apos;t Smoke </p>
            <p>&gt;&gt;&gt; print(berkantaslan[&quot;Blood Group&quot;]) # 🩸 </p>
            <p> A RH(+) </p>
            <p>&gt;&gt;&gt; print(berkantaslan[&quot;Birth Year&quot;]) # 👼🏻 </p>
            <p> 1993 </p>
            <p>&gt;&gt;&gt; print(berkantaslan[&quot;Marriage Status&quot;]) # 👰🏻🤵🏻 </p>
            <p> Married </p>

        </>;
    }

    function skillsText() {
        return <>
            <dl className="aboutMeText1">
			<p><span style={{color: infoEn.baseColor}}>C:\Users\berkantaslan&gt;</span> python </p>
			<p><span style={{color: infoEn.baseColor}}>C:\Users\berkantaslan&gt;</span> Python 3.10.11 (tags/v3.10.11:7d4cc5a, Apr 5 2023, 00:38:17) [MSCv.1929 64 bit (AMD64)] on win32
				Type &quot;help&quot;, &quot;copyright&quot;, &quot;credits&quot; or &quot;license&quot; for more information. </p>
			<p>&gt;&gt;&gt; import pymongo</p>
			<p>&gt;&gt;&gt; myclient = pymongo.MongoClient(&quot;mongodb://localhost:27017/&quot;)</p>
			<p>&gt;&gt;&gt; mydb = myclient[&quot;AboutBerkantAslan&quot;]</p>
			<p>&gt;&gt;&gt; mycol = mydb[&quot;Experience&quot;]</p>
			<p>&gt;&gt;&gt; for data in cursor: data = parse_json(data)</p>
            <p>&gt;&gt;&gt; cursor = mycol.find()</p>
            </dl>
			<p>&gt;&gt;&gt; for data in cursor: print(&quot;Python3: &quot; + int(data[&quot;Python3&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Python3: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Artificial Intelligence: &quot; + int(data[&quot;Artificial Intelligence&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Artificial Intelligence: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Data Science: &quot; + int(data[&quot;Data Science&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Data Science: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Machine Learning&quot; + int(data[&quot;Machine Learning&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Machine Learning: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Deep Learning&quot; + int(data[&quot;Deep Learning&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Deep Learning: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Computer Vision & Image Processing&quot; + int(data[&quot;Computer Vision & Image Processing&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Computer Vision & Image Processing: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Javascript&quot; + int(data[&quot;Javascript&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Javascript: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;React&quot; +
            int(data[&quot;React&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> React: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Flutter&quot; + int(data[&quot;Flutter&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Flutter: ⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;HTML&quot; + int(data[&quot;HTML&quot;])*u&quot;\u2B50&quot;)</p>
            <p> HTML: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;CSS&quot; + int(data[&quot;CSS&quot;])*u&quot;\u2B50&quot;)</p>
            <p> CSS: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;C#&quot; + int(data[&quot;C#&quot;])*u&quot;\u2B50&quot;)</p>
            <p> C#: ⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;C&quot; + int(data[&quot;C&quot;])*u&quot;\u2B50&quot;)</p>
            <p> C: ⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;C++&quot; + int(data[&quot;C++&quot;])*u&quot;\u2B50&quot;)</p>
            <p> C++: ⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;MongoDB&quot; + int(data[&quot;MongoDB&quot;])*u&quot;\u2B50&quot;)</p>
            <p> MongoDB: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p> MySQL: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;MS SQL&quot; +
            int(data[&quot;MS SQL&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> MS SQL: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;R&quot; +
            int(data[&quot;R&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;R&quot; + int(data[&quot;R&quot;])*u&quot;\u2B50&quot;)</p>
            <p> R: ⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Big Data&quot; + int(data[&quot;Big Data&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Big Data: ⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Tableau&quot; + int(data[&quot;Tableau&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Tableau: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;PowerBI&quot; +
            int(data[&quot;PowerBI&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> PowerBI: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Microstrategy&quot; + int(data[&quot;Microstrategy&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Microstrategy: ⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Linux&quot; + int(data[&quot;Linux&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Linux: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Cyber Security&quot; + int(data[&quot;Cyber Security&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Cyber Security: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Robotics&quot; +
            int(data[&quot;Robotics&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Robotics: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Systems & Network&quot; + int(data[&quot;Systems & Network&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Systems & Network: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;SPSS&quot; + int(data[&quot;SPSS&quot;])*u&quot;\u2B50&quot;)</p>
            <p> SPSS: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Minitab&quot; + int(data[&quot;Minitab&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Minitab: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Matlab&quot; + int(data[&quot;Matlab&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Matlab: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Mathematica&quot; + int(data[&quot;Mathematica&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Mathematica: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Microsoft Excel&quot; + int(data[&quot;Microsoft Excel&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Microsoft Excel: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;JSON&quot; +
            int(data[&quot;JSON&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> JSON: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;YAML&quot; +
            int(data[&quot;YAML&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> YAML: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;XML&quot; +
            int(data[&quot;XML&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> XML: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Solidworks&quot; +
            int(data[&quot;Solidworks&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Solidworks: ⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;AutoCAD&quot; +
            int(data[&quot;AutoCAD&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> AutoCAD: ⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;AnSYS&quot; +
            int(data[&quot;AnSYS&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> AnSYS: ⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;PLC&quot; +
            int(data[&quot;PLC&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> PLC: ⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;MQTT&quot; +
            int(data[&quot;MQTT&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> MQTT: ⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;UiPath&quot; +
            int(data[&quot;UiPath&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> UiPath: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Selenium&quot; +
            int(data[&quot;Selenium&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Selenium: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Postman&quot; +
            int(data[&quot;Postman&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Postman: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Git&quot; +
            int(data[&quot;Git&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Git: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Jetson Nano/Orin&quot; +
            int(data[&quot;Jetson Nano/Orin&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Jetson Nano/Orin: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Raspberry Pi&quot; +
            int(data[&quot;Raspberry Pi&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Raspberry Pi: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;Arduino&quot; +
            int(data[&quot;Arduino&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> Arduino: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;ROS&quot; +
            int(data[&quot;ROS&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> ROS: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;JWT&quot; +
            int(data[&quot;JWT&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> JWT: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
            <p>
            &gt;&gt;&gt; for data in cursor: print(&quot;QT&quot; +
            int(data[&quot;QT&quot;])*u&quot;\u2B50&quot;)
            </p>{" "}
            <p> QT: ⭐️⭐️⭐️⭐️⭐️ </p>{" "}
        </>;
    }

    function languageSkillsText() {
        return <>
            <dl className="aboutMeText2">
            <p><span style={{ color: infoEn.baseColor }}>C:\Users\berkantaslan&gt;</span> python </p>
            <p><span style={{ color: infoEn.baseColor }}>C:\Users\berkantaslan&gt;</span> Python 3.10.11 (tags/v3.10.11:7d4cc5a, Apr 5 2023, 00:38:17) [MSCv.1929 64 bit (AMD64)] on win32
                Type &quot;help&quot;, &quot;copyright&quot;, &quot;credits&quot; or &quot;license&quot; for more information. </p>
            <p>&gt;&gt;&gt; import pymongo</p>
            <p>&gt;&gt;&gt; myclient = pymongo.MongoClient(&quot;mongodb://localhost:27017/&quot;)</p>
            <p>&gt;&gt;&gt; mydb = myclient[&quot;AboutBerkantAslan&quot;]</p>
            <p>&gt;&gt;&gt; mycol = mydb[&quot;Experience&quot;]</p>
            <p>&gt;&gt;&gt; for data in cursor: data = parse_json(data)</p>
            <p>&gt;&gt;&gt; cursor = mycol.find()</p>
            </dl>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;Turkish: &quot; + int(data[&quot;Turkish&quot;])*u&quot;\u2B50&quot;)</p>
            <p> Turkish: ⭐️⭐️⭐️⭐️⭐️ </p>
            <p>&gt;&gt;&gt; for data in cursor: print(&quot;English: &quot; + int(data[&quot;English&quot;])*u&quot;\u2B50&quot;)</p>
            <p> English: ⭐️⭐️⭐️⭐️⭐️ </p>
        </>;
    }
    function miscText() {
        return <>
            <p>
            <span style={{ color: infoEn.baseColor }}>
                {firstName}
                {infoEn.lastName.toLowerCase()}
            </span>{":$ "}
            cd hobbies/interests
            </p>{" "}
            <p>
            <p>
            <span style={{ color: infoEn.baseColor }}>
                {firstName}
                {infoEn.lastName.toLowerCase()}
            </span>{":"}
                <span className={Style.green}>/hobbies/interests</span>$ ls
            </p>{" "}
            </p>{" "}
            <ul>
                {infoEn.hobbies.map((hobby, index) => (
                    <li key={index}><Box component={'span'} mr={'1rem'}>{hobby.emoji}</Box>{hobby.label}</li>
                ))}
            </ul>
        </>;
    }

    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'}>
            <Terminal text={aboutMeText()}/>
            <Terminal text={skillsText()} />
            <Terminal text={languageSkillsText()} />
            <Terminal text={miscText()}/>
        </Box>
    )
}